// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_1aE9c{align-items:center;display:flex;flex:0 1 auto;font-size:15px;font-weight:400;justify-content:center;line-height:normal;min-width:60px;max-width:360px;outline:none;padding:0 18px;position:relative;color:inherit;text-align:center;text-decoration:none;transition:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:normal;cursor:pointer}.container_1aE9c:not(.active_19O-e){color:#63666a}", ""]);
// Exports
exports.locals = {
	"container": "container_1aE9c",
	"active": "active_19O-e"
};
module.exports = exports;
